"use client"

import { MapPin, Phone, Mail, Clock } from "lucide-react"
import { useSettings } from "@/lib/settings-context"

export function ContactInfo() {
  const { settings } = useSettings()
  
  const contactDetails = [
    {
      icon: MapPin,
      title: "Our Location",
      details: [settings.address, "Serving all of Michigan and beyond"],
    },
    {
      icon: Phone,
      title: "Phone",
      details: [settings.phoneNumber, "Mon-Fri: 7AM - 6PM EST"],
    },
    {
      icon: Mail,
      title: "Email",
      details: [settings.email],
    },
    {
      icon: Clock,
      title: "Business Hours",
      details: ["Monday - Friday: 7:00 AM - 6:00 PM", "Saturday: By Appointment", "Sunday: Closed"],
    },
  ]
  return (
    <div className="space-y-6">
      <div>
        <h2 className="mb-4 text-2xl font-bold text-foreground">Contact Information</h2>
        <p className="text-muted-foreground">
          Reach out to us through any of the channels below. We&apos;re here to help with all your infrastructure needs.
        </p>
      </div>
      
      {/* Contact Cards */}
      <div className="space-y-4">
        {contactDetails.map((item, index) => {
          const IconComponent = item.icon
          const isEven = index % 2 === 0
          
          return (
            <div
              key={item.title}
              className="flex gap-4 rounded-xl border border-border/50 bg-card p-5"
            >
              <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${isEven ? "bg-primary/10" : "bg-accent/10"}`}>
                <IconComponent className={`h-6 w-6 ${isEven ? "text-primary" : "text-accent"}`} />
              </div>
              <div>
                <h3 className="mb-1 font-semibold text-foreground">{item.title}</h3>
                {item.details.map((detail) => (
                  <p key={detail} className="text-sm text-muted-foreground">
                    {detail}
                  </p>
                ))}
              </div>
            </div>
          )
        })}
      </div>

      {/* Service Area */}
      <div className="rounded-xl border border-accent/30 bg-accent/10 p-6">
        <h3 className="mb-3 font-semibold text-foreground">Service Area</h3>
        <p className="mb-4 text-sm text-muted-foreground">
          Headquartered in Ann Arbor, Michigan, we proudly serve clients throughout the entire state of Michigan and beyond. Our expertise and capability allow us to take on challenging nationwide infrastructure projects.
        </p>
        <p className="text-sm font-medium text-foreground">
          No project is too distant—we welcome the opportunity to bring our expertise to your location.
        </p>
      </div>
    </div>
  )
}
